import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { first, finalize } from 'rxjs/operators';
import { AuthService } from '../_services/auth.service';
import { AlertService } from '../_services/alert.service';
import { UserService } from '../share/services/user.service';
import { NavigationService } from '../share/services/navigation.service';
import { CategoryDTO } from '../share/model/CategoryDTO';
import { ResourceService } from '../share/services/resource.service';
import { LocalStorageService } from '../share/services/local-storage.service';

const passwordPolicyValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as string;

    if (!value) {
        return null;
    }

    const exactLength = value.length === 8;
    const hasUpper = /[A-Z]/.test(value);
    const hasLower = /[a-z]/.test(value);
    const hasNumber = /\d/.test(value);

    const policyErrors: any = {};

    if (!exactLength) {
        policyErrors.exactLength = true;
    }
    if (!hasUpper) {
        policyErrors.hasUpper = true;
    }
    if (!hasLower) {
        policyErrors.hasLower = true;
    }
    if (!hasNumber) {
        policyErrors.hasNumber = true;
    }

    return Object.keys(policyErrors).length ? { passwordPolicy: policyErrors } : null;
};

@Component({
    templateUrl: 'register.component.html',
    styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

    registerForm: FormGroup;
    isLoading = false;
    submitted = false;
    errorMessage = '';
    successMessage = '';
    isPasswordValid: boolean = false;
    hasCharacter: boolean = false;
    hasUpper: boolean = false;
    hasLower: boolean = false;
    hasNumber: boolean = false;
    categories: CategoryDTO[] = [];
    isLoadingData: boolean = false;
    showPassword: boolean = false;
    showRepeatPassword: boolean = false;

    private lowerExp = /[a-z]/;
    private upperExp = /[A-Z]/;
    private numberExp = /\d/;

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private navigationService: NavigationService,
        private resourceService: ResourceService,
        private localStorageService: LocalStorageService
        ) { }

    ngOnInit() {
        this.getCategories();
        this.registerForm = this.formBuilder.group({
            email: ['', Validators.required],
            validationCode: ['', Validators.required],
            password: ['', [Validators.required, passwordPolicyValidator]],
            repeatPassword: ['', [Validators.required, Validators.minLength(6)]],
            //categoryOneID: ['', Validators.required],
            //categoryTwoID: ['', Validators.required],
            //categoryThreeID: ['', Validators.required]
        });
        this.route.queryParams.subscribe(params => {
            let email = params['email'];
            let validationCode = params['validationCode'];
            this.registerForm.patchValue({
                'email': email,
                'validationCode': validationCode
            })
            if (email) {
                this.registerForm.controls['email'].disable();
            }
            if (validationCode) {
                this.registerForm.controls['validationCode'].disable();
            }
        });
    }

    // convenience getter for easy access to form fields
    get f() { return this.registerForm.controls; }

    togglePasswordVisibility() {
        this.showPassword = !this.showPassword;
    }

    toggleRepeatPasswordVisibility() {
        this.showRepeatPassword = !this.showRepeatPassword;
    }

    getCategories() {
        this.isLoadingData = true;
        this.resourceService.getResourceCategories()
            .pipe(finalize(() => {
                //this.changeDetectorRef.detectChanges();
                this.isLoadingData = false;
            }))
            .subscribe(
                (res) => {
                    this.categories = res;
                },
                (err) => {
                    console.log("ERR ", err);
                }
            )
    }

    tryRegister() {
        this.submitted = true;
        if (!this.registerForm.valid) {
            return;
        }
        this.isLoading = true;
        let data = {
            email: this.f.email.value,
            password: this.f.password.value,
            confirmPassword: this.f.repeatPassword.value,
            invitationCode: this.f.validationCode.value,
            termsAndCondition: true,
            //categoryOneID: this.f.categoryOneID.value,
            //categoryTwoID: this.f.categoryTwoID.value,
            //categoryThreeID: this.f.categoryThreeID.value,
        }
        this.userService.register(data)
            .pipe(finalize(() => {
                this.isLoading = false;
                //this.changeDetectorRef.detectChanges();
            }))
            .subscribe(
                (user) => {
                    console.log("USER ", user);
                    this.localStorageService.setUser(user);
                    if (user.isSuperAdmin()) {
                        this.navigationService.goToClients();
                    } else if (user.isCollaborator()) {
                        this.navigationService.goToPollResponse();
                    } else {
                        this.navigationService.goToHome();
                    }
                },
                (error) => {
                    console.log("ERR ", error);
                }
            )
    }

    chagePassword(value) {
        console.log("EVENT ", value)

        this.hasCharacter = value && value.length === 8;
        this.hasUpper = this.upperExp.test(value);
        this.hasLower = this.lowerExp.test(value);
        this.hasNumber = this.numberExp.test(value);

        if (this.hasCharacter && this.hasUpper && this.hasLower && this.hasNumber) {
            this.isPasswordValid = true;
        } else {
            this.isPasswordValid = false;
        }
    }


}
